import { useState, useEffect } from "react";

const API="https://rickandmortyapi.com/api/character"

const Api = () => {
    const [characters ,setCharacters] = useState([])

    useEffect(() => {
        /// llamado a la api
        fetch(API)
            .then(response => response.json())
            .then(data => setCharacters(data.results))
        /// si esta vacio [ ] solo se ejecuta una vez
    }, []);
    return characters;
};

export default Api;